<template>
    <v-container max-width="100%">
        <merus-data-table
            :headers="headers"
            :items="veiculos"
            :loading="loading"
            :default-multi-sort="defaultMultiSort"
            :loading-text="$t('vehicleAuthorization.loading')"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('vehicleAuthorization.title')"
                    :token="token"
                    hide-search
                >
                </CadastroToolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon dark :color="getCorBotaoAutorizar(item)" @click="autorizarVeiculo(item)" small>mdi-check-circle</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import translateDbField from "@/utils/translateDbField";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
        user: null,
        token: null,
        veiculos: [],
        loading: false,
    }),
    computed: {
        headers() {
            return [
                { text: this.$t('vehicle.code'), value: "cod_veiculo", sortable: true, filtrable: true },
                { text: this.$t('vehicleAuthorization.authorized'), value: "autorizado_prefeitura_extenso", sortable: true, filtrable: true },
                { text: this.$t('vehicleAuthorization.type'), value: "descricao_tipo_veiculo_translated", sortable: true, filtrable: true },
                { text: this.$t('tariffs.self'), value: "descricao_tarifa", sortable: true, filtrable: true },
                { text: this.$t('vehicleAuthorization.headers.actions'), value: "actions", sortable: false, filtrable: false }
            ];
        },
        defaultMultiSort() {
            return [
            { value: "cod_veiculo", options: { text: this.$t('system.labels.increasing'), value: 1 } },
            { value: "autorizado_prefeitura_extenso", options: { text: this.$t('system.labels.decreasing'), value: -1 } }
        ];

        },
        erro() {
            return {
                tipo: this.$t('vehicleAuthorization.headers.system'),
                mensagem: this.$t('system.unknownSystemError'),
                status: null
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    async created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        await this.initialize();
    },
    methods: {
        async initialize() {
            this.veiculos = await this.getVeiculos();
        },
        async getVeiculos() {
            this.loading = true;
            const response = await apiController.request(apiController.endpoints.getVeiculossubsidio, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loading = false;
            return response.data.map(veiculo => {
                const translated = translateDbField(
                    veiculo.translation_key,
                    veiculo.descricao_tipo_veiculo
                );
                return {
                    ...veiculo,
                    descricao_tipo_veiculo_translated: translated,
                    autorizado_prefeitura_extenso: veiculo.autorizado_prefeitura === 1 ? this.$t('system.yes') : this.$t('system.no')
                };
            });
        },
        getCorBotaoAutorizar(item) {
            return item.autorizado_prefeitura == 1 ? "green" : "red";
        },
        async autorizarVeiculo(item) {
            item.autorizado_prefeitura = item.autorizado_prefeitura == 1 ? 0 : 1;
            item.id_usuario = this.user.id_usuario;
            const response = await apiController.request(apiController.endpoints.updateAutorizacaoprefeitura, { data: item, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }
            if (response.data.erro) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            this.veiculos = await this.getVeiculos();
        },
    }
}
</script>

<style lang="">
    
</style>